<template>
  <div>
    <b-card>
      <b-row>
        <b-col cols="12" xl="6" lg="6" md="6">
          <b-row style="align-items: center;">
            <b-col cols="4">
              <h4>ภาพรวมยอดเงิน</h4>
              <p>การถอนเงิน</p>
            </b-col>
            <b-col cols="4">
              <h3>{{ userData.balance.toLocaleString("en-US") }} ฿</h3>
            </b-col>
            <!-- <b-col cols="4">
              <b-button v-b-modal.modal-center variant="primary">
                ถอนเงิน
              </b-button>
            </b-col> -->
          </b-row>
        </b-col>
        <b-col
          cols="12"
          xl="6"
          lg="6"
          md="6"
          style="border-left: 1px solid #ebe9f1;"
          v-if="bankDefault.accountNumber"
        >
          <h4>บัญชีธนาคารของฉัน</h4>
          <div class="d-flex mt-1">
            <p>{{ bankDefault.bankName }}</p>
            <p class="ml-3">
              ****
              {{
                bankDefault.accountNumber && bankDefault.accountNumber.slice(6)
              }}
            </p>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      id="modal-center"
      centered
      title="ถอนเงิน"
      size="lg"
      ref="modal-user"
      @ok="handlerFinanceAddOrUdpate"
      ok-only
    >
      <b-row style="justify-content: center; display: flex;">
        <b-col cols="8">
          <b-form-group label="ยอดเงิน" label-cols="3">
            <div class="d-flex">
              <b-form-input id="subDescription" type="number" v-model="amout" />
              <span style="font-size: 1.5rem;" class="pt-50 pl-1">฿</span>
            </div>
          </b-form-group>
          <b-form-group label="ชื่อธนาคาร" label-cols="3">
            <v-select
              v-model="selected"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="optionsBank"
            />
          </b-form-group>
          <b-form-group label="เลขที่บัญชี" label-cols="3">
            <b-form-input id="lineNo" v-model="selected.value" />
          </b-form-group>
          <!-- <div class="d-flex justify-content-center">
            <b-button variant="primary" @click="handlerFinanceAddOrUdpate">
              ตกลง
            </b-button>
          </div> -->
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard,
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import vSelect from "vue-select";
import store from "@/store";
import router from "@/router";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ref, onUnmounted } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BFormGroup,
    vSelect,
    BFormInput,
    ToastificationContent,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      selected: { title: "กรุณาเลือก" },

      option: [{ title: "Active" }, { title: "Inactive" }],
      amout: 0,
      // bankDefault: {},
    };
  },
  setup() {
    const optionsBank = ref([{ value: "", text: "" }]);
    const bankDefault = ref({});
    store
      .dispatch("sell-balance/getBankAccountList")
      .then((response) => {
        if (response !== null) {
          response.data.data.forEach((data) => {
            optionsBank.value.push({
              value: data.accountNumber,
              title: data.bankName,
              bankId: data.bankId,
              accountName: data.accountName,
            });
            if (data.isDefault) {
              bankDefault.value = data;
            }
          });
        }
      })
      .catch((error) => {
        this.showToast("danger", "XCircleIcon", error.response.data);
      });

    return {
      optionsBank,
      bankDefault,
    };
  },
  mounted() {
    // if (router.currentRoute.params.isEdit == true) {
    //   this.$refs["modal-user"].show();
    // }
  },
  methods: {
    showToast(variant, icon, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon,
          text,
          variant,
        },
      });
    },
    handlerFinanceAddOrUdpate() {
      // const userData = getUserData();
      // console.log("userData ", userData);
      let payload = {
        financeHistoryId: "00000000-0000-0000-0000-000000000000",
        accountName: this.selected.accountName,
        accountNumber: this.selected.value,
        bankId: this.selected.bankId,
        bankName: this.selected.title,
        amountMoney: this.amout,
        amountMoneyOld: 0,
      };
      store
        .dispatch("sell-balance/getFinanceAddOrUdpate", payload)
        .then((response) => {
          if (response.status == 200) {
            this.$bvToast.toast("การทำรายการ", {
              title: `ทำรายการสำเร็จ`,
              variant: "success",
              solid: true,
            });
            store
              .dispatch("sell-balance/getFinancesOverview")
              .then((response) => {
                this.userData = response.data.data;
              })
              .catch((error) => {
                if (error.response.status === 404) {
                  this.userData = undefined;
                }
              });
          } else {
            this.$bvToast.toast("ทำรายการไม่สำเร็จ", {
              title: `การทำรายการ`,
              variant: "danger",
              solid: true,
            });
          }
        })
        .catch((error) => {
          this.$bvToast.toast("ทำรายการไม่สำเร็จ", {
            title: `การทำรายการ`,
            variant: "danger",
            solid: true,
          });
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
